import Vue from 'vue';
import { MutationTree } from "vuex";
import { SubscriptionDescriptionAdminzoneState } from "@/types/store/adminzone";
import { SubscriptionDescriptionsData } from "@/types";

export const mutations: MutationTree<SubscriptionDescriptionAdminzoneState> = {
  SET_SUBSCRIPTION_DESCRIPTIONS: (state, payload: Array<SubscriptionDescriptionsData>): Array<SubscriptionDescriptionsData> => Vue.set(state, 'subscriptionDescriptions', payload)
}
